import { apiRequestWithConfig } from '@lib/api-fetch';
import { ApplyBonusCardRequest } from 'types/checkout';
import { GcmResponse } from 'types/gcmResponse';
import { ClientSafeConfig } from '@lib/context/config-context';
import { fetch_timeout_duration } from '@lib/constants/network-constants';
import { getRuntimeConfig } from '@lib/util/runtime-config-util';


export async function applyBonusCard(param: ApplyBonusCardRequest, config?: ClientSafeConfig): Promise<GcmResponse> {
  // Auto-fetch config from window if not provided
  const runtimeConfig = getRuntimeConfig(config);
  const response = await apiRequestWithConfig(
    'POST',
    `/bonus-card/apply`,
    {
      body: param,
    },
    '',
    false,
    '',
    fetch_timeout_duration,
    false,
    true,
    runtimeConfig
  );
  return response.body;
}

export async function removeBonusCard(cart_id: string, config?: ClientSafeConfig): Promise<GcmResponse> {
  // Auto-fetch config from window if not provided
  const runtimeConfig = getRuntimeConfig(config);
  const response = await apiRequestWithConfig(
    'DELETE',
    `/bonus-card/${cart_id}`,
    {},
    '',
    false,
    '',
    fetch_timeout_duration,
    false,
    true,
    runtimeConfig
  );
  return response.body;
}

export async function reApplyBonusCard(cart_id: string, config?: ClientSafeConfig): Promise<GcmResponse> {
  // Auto-fetch config from window if not provided
  const runtimeConfig = getRuntimeConfig(config);
  const response = await apiRequestWithConfig(
    'POST',
    `/bonus-card/re-apply`,
    { body: { cart_id } },
    '',
    false,
    '',
    fetch_timeout_duration,
    false,
    true,
    runtimeConfig
  );
  return response.body;
}
